/**
 * Search sort fields for Lucene sorting.
 * Returns sortFields with the value inserted or toggled.
 * Eg. ProductionAtmostEndYear:desc,NameSorted:asc
 */
export const getToggledSortFields = function (value, sortFields, clear) {
    let fields = {};
    if (sortFields && clear !== true) {
        // parse all fields
        fields = _.fromPairs(_.map(sortFields.split(','), (pair) => {
            return pair.split(':');
        }));
    }

    const [ key, order ] = value.split(':');

    // toggle selected field sort order asc/desc
    if (order === 'asc') {
        fields[key] = 'desc';
    }
    else if (order === 'desc') {
        fields[key] = 'asc';
    }
    else {
        // leave as-is
        fields[key] = order;
    }

    // format sortFields
    const _sortFields = _.map(fields, (key, val) => { return `${val}:${key}`; }).join(',');
    return _sortFields;
};

/**
 * Return sort operations for SQL sorting.

 * The implementation is spread between these sort functions here
 * and the SortOption component.
 *
 * Value can be removed by prefixing it with '--'.
 * ProductionTime switches both Asc|Desc suffix and Latest|Earliest
 *
 * @param value --  new operation state, eg. 'ArtistAsc' or 'ArtistDesc'
 * @param clear --  clear all sort options before adding value
 */
export const getToggledSortOperations = function (value, sortOperations, clear) {
    // copy operations
    const _sortOperations = clear ? [] : _.extend(sortOperations);

    if (value) {
        if (value.match(/^--/)) {
            // remove this value from `_sortOperations`
            _.pull(_sortOperations, value.replace(/^--/, ''));
        }
        else {
            // check if version of value exists in options already
            let found = false;
            const matchValue = value.replace(/asc|desc/i, '');

            _sortOperations.forEach((op, i) => {
                if (!found && op) {
                    if (op.match(matchValue)
                        || (op.match('ProductionTime') && matchValue.match('ProductionTime'))) {

                        // replace respective item in `_sortOperations`
                        _sortOperations[i] = value;
                        found = true;
                    }
                }
            });
            if (!found) {
                // add new value to `_sortOperations`
                _sortOperations.push(value);
            }
        }
    }

    return _sortOperations;
};


export default {

    data: function () {
        return {
            sortFields: '',      // Lucene sorting
            sortOperations: [],  // SQL sorting
            debouncedMasonryReset: () => {} // implement in view
        };
    },

    methods: {
        getToggledSortFields,
        getToggledSortOperations,

        /**
         * Set artworks / search results by setting a sort field
         * that goes to the backend in the next request.
         * Eg. ProductionAtmostEndYear:desc,NameSorted:asc
         */
        toggleSortField: function (value, clear) {
            this.sortFields = this.getToggledSortFields(value, this.sortFields, clear);

            this.debouncedMasonryReset();
        },

        /**
         * Change sort operation state in `this.sortOperations`.
         *
         * Value can be removed by prefixing it with '--'.
         * ProductionTime switches both Asc|Desc suffix and Latest|Earliest
         *
         * @param value --  new operation state, eg. 'ArtistAsc' or 'ArtistDesc'
         * @param clear --  clear all sort options before adding value
         */
        setSortOperation: function (value, clear) {
            this.sortOperations = this.getToggledSortOperations(value, this.sortOperations, clear);

            this.debouncedMasonryReset();
        }
    }
};
